import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from '../components/Header'
import Footer from '../components/Footer'

import '../../node_modules/bootstrap/dist/css/bootstrap.css'
import './index.css'

const meta = {
  title: 'Ridley Owen & Sons - Build, Refurbish, Maintain',
  description: 'We are a small family run business be rest assured that when dealing with us you get that personal touch that other big companies cannot provide. We cover small building works, refurbishments and maintenance and have the wealth of knowledge to ensure your happy with the service we can give you.',
  keywords: 'Build,Refurbish,Maintain',
  image: 'http://www.ridleyowenandsons.com/banner.jpg',
  url: 'http://www.ridleyowenandsons.com'
}

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title={meta.title}
      meta={[
        { name: 'description', content: meta.description },
        { name: 'keywords', content: meta.keywords },
        { itemprop: 'name', content: meta.title },
        { itemprop: 'image', content: meta.image },
        { itemprop: 'description', content: meta.description },
        { property: 'og:title', content: meta.title },
        { property: 'og:type', content: "website" },
        { property: 'og:description', content: meta.description },
        { property: 'og:image', content: meta.image },
        { property: 'og:url', content: meta.url },
        { name: 'twitter:card', content: "summary" },
        { name: 'twitter:title', content: meta.title },
        { name: 'twitter:description', content: meta.description },
        { name: 'twitter:image', content: meta.image },
        { name: 'twitter:url', content: meta.url },
        { name: 'msapplication-TileColor', content: '#2b5797' },
        { name: 'theme-color', content: '#ffffff'}
      ]}
      link={[
        { rel: 'apple-touch-icon', sizes: '180x180', href: '/apple-touch-icon.png' },
        { rel: 'icon', type: 'image/png', sizes: '32x32', href: '/favicon-32x32.png' },
        { rel: 'icon', type: 'image/png',sizes: '16x16', href: '/favicon-16x16.png' },
        { rel: 'manifest', href: '/site.webmanifest' },
        { rel: 'mask-icon', href: '/safari-pinned-tab.svg', color: '#01033f' }
      ]}
    />
    <Header />

    <div>
      {children()}
    </div>

    <Footer />
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js